import ReactPhoneInput, { PhoneInputProps } from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

export const PhoneInput = ({ value, ...props }: PhoneInputProps) => {
  return (
    <ReactPhoneInput
      value={value?.toString()}
      inputStyle={{
        height: '32px',
        width: '100%',
        borderRadius: '6px'
      }}
      country="md"
      {...props}
    />
  )
}
